export interface UserInfoFlow {
  userInfo: boolean
  kyc: boolean
  wallet: {
    hasWallet: boolean
    isWalletless: boolean
  }
  billingAddress: boolean
}

export interface UserInfoFlowStep {
  key: UserInfoFlowSteps
  label: string
}

export enum UserInfoFlowSteps {
  USER_INFO = 'USER_INFO',
  KYC = 'KYC',
  WALLET = 'WALLET',
  BILLING_ADDRESS = 'BILLING_ADDRESS',
}

export enum UserInfoFlowStepStatus {
  COMPLETED = 'COMPLETED',
  CURRENT = 'CURRENT',
  PENDING = 'PENDING',
}
